//HomePage.jsx

import React from "react";
import {Link} from "react-router-dom";
import graphImage from "../assets/graph.png";
import hotspotsImage from "../assets/hotspots.png";
import "../styles/HomePage.css";


const XIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M18.9 2H22l-6.8 7.8L23.2 22h-6.3L12 13.9 4.9 22H1.8l7.3-8.4L1.3 2h6.5l4.5 7.5L18.9 2Zm-1.1 17.9h1.7L6.8 4H5L17.8 19.9Z"/>
    </svg>
);

const RedditIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M14.8 3.2a1.7 1.7 0 0 0-3.3.6l-.8 4.1a12 12 0 0 0-5.1 1.5 2.2 2.2 0 1 0-2.3 3.6c-.1.4-.2.8-.2 1.2 0 3.5 4 6.3 8.9 6.3s8.9-2.8 8.9-6.3c0-.4-.1-.8-.2-1.2a2.2 2.2 0 1 0-2.3-3.6 12 12 0 0 0-5.1-1.5l.6-3 3.1.7a1.7 1.7 0 1 0 .3-1.5l-4-1-.5.1-.7 3.6Zm-6 7.6a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Zm6.4 5.3a4.2 4.2 0 0 1-5.4 0 .7.7 0 0 1 1-1 2.8 2.8 0 0 0 3.4 0 .7.7 0 1 1 1 1Zm.1-2.5a1.4 1.4 0 1 1 0-2.8 1.4 1.4 0 0 1 0 2.8Z"/>
    </svg>
);

const DiscordIcon = () => (
    <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M19.7 5.1A18.5 18.5 0 0 0 15.1 3.7l-.6 1.2a17 17 0 0 0-5 0l-.6-1.2a18.5 18.5 0 0 0-4.6 1.4C1.4 9.4.6 13.6 1 17.8a18.7 18.7 0 0 0 5.7 2.9l1.2-1.9-1.9-.9.5-.4c3.7 1.7 7.7 1.7 11.4 0l.5.4-1.9.9 1.2 1.9a18.7 18.7 0 0 0 5.7-2.9c.5-4.9-.8-9.1-3.7-12.7ZM8.7 14.9c-1.1 0-2-1-2-2.2s.9-2.2 2-2.2 2 1 2 2.2-.9 2.2-2 2.2Zm6.6 0c-1.1 0-2-1-2-2.2s.9-2.2 2-2.2 2 1 2 2.2-.9 2.2-2 2.2Z"/>
    </svg>
);


const Feature=({title,children})=>(
    <div className="landing-feature">
        <div className="landing-feature-icon"></div>
        <h3>{title}</h3>
        <p>{children}</p>
    </div>
);

const ProductImage=({src,alt})=>(
    <div className="landing-shot-wrap">
        <div className="landing-shot">
            <img src={src} alt={alt}/>
        </div>
    </div>
);

export default function HomePage(){
    return(
        <div className="landing-page">
            <header className="landing-header">
                <div className="landing-header-inner">
                    <Link to="/" className="landing-logo">Custor</Link>
                    <nav className="landing-nav">
                        <Link to="/login" className="landing-nav-login">Login</Link>
                        <Link to="/register" className="landing-button landing-button-primary">
                            Get Started
                        </Link>
                    </nav>
                </div>
            </header>

            <main>
                <section className="landing-hero">
                    <div className="landing-hero-inner">
                        <p className="landing-eyebrow">Software architecture analysis</p>
                        <h1>
                            Understand your codebase.
                            <span>See how it is structured.</span>
                        </h1>
                        <p className="landing-hero-text">
                            Custor analyzes software repositories and helps developers understand
                            architecture, dependencies, modules, code metrics and structural issues.
                        </p>
                        <div className="landing-hero-actions">
                            <Link to="/register" className="landing-button landing-button-primary">
                                Get Started
                            </Link>
                            <Link to="/login" className="landing-button landing-button-secondary">
                                Login
                            </Link>
                        </div>
                    </div>
                </section>

                <section className="landing-section landing-section-dark">
                    <div className="landing-section-inner">
                        <div className="landing-split">
                            <div className="landing-copy landing-copy-left">
                                <p className="landing-eyebrow">Architecture</p>
                                <h2>See how your codebase is connected.</h2>
                                <p>
                                    Explore modules and relationships between different parts of
                                    your software through an interactive architecture graph.
                                </p>
                                <Link to="/register" className="landing-button landing-button-secondary">
                                    Explore Custor
                                </Link>
                            </div>

                            <div className="landing-visual">
                                <ProductImage src={graphImage} alt="Custor Architecture Graph"/>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-section landing-section-hotspots">
                    <div className="landing-section-inner">
                        <div className="landing-split landing-split-reverse">
                            <div className="landing-copy landing-copy-left">
                                <p className="landing-eyebrow">Code insights</p>
                                <h2>Find the parts of your system that deserve attention.</h2>
                                <p>
                                    Custor helps identify structural hotspots and understand where
                                    complexity and dependencies are concentrated in your codebase.
                                </p>
                            </div>

                            <div className="landing-visual">
                                <ProductImage src={hotspotsImage} alt="Custor architectural hotspots"/>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-section landing-section-dark">
                    <div className="landing-section-inner">
                        <div className="landing-center">
                            <p className="landing-eyebrow">What Custor does</p>
                            <h2>Turn a complex codebase into something you can explore.</h2>
                            <p className="landing-center-text">
                                Instead of looking at thousands of files individually, Custor gives
                                you a higher-level view of the structure and relationships inside
                                your software.
                            </p>
                        </div>

                        <div className="landing-features">
                            <Feature title="Architecture">
                                Explore how your software is organized and how its modules relate
                                to each other.
                            </Feature>
                            <Feature title="Dependencies">
                                Understand connections between different parts of the codebase and
                                discover important dependencies.
                            </Feature>
                            <Feature title="Code insights">
                                Inspect metrics and structural issues that can make a system harder
                                to understand and maintain.
                            </Feature>
                        </div>
                    </div>
                </section>

                <section className="landing-section">
                    <div className="landing-section-inner">
                        <div className="landing-center">
                            <p className="landing-eyebrow">How it works</p>
                            <h2>From repository to understanding.</h2>
                            <p className="landing-center-text">
                                Start with a repository and move from raw source code to a clearer
                                picture of how the system is built.
                            </p>
                        </div>

                        <div className="landing-steps">
                            <div className="landing-step">
                                <div className="landing-step-number">1</div>
                                <h3>Create an account</h3>
                                <p>Sign up and access your Custor workspace.</p>
                            </div>

                            <div className="landing-step">
                                <div className="landing-step-number">2</div>
                                <h3>Submit a repository</h3>
                                <p>Give Custor the software project you want to understand.</p>
                            </div>

                            <div className="landing-step">
                                <div className="landing-step-number">3</div>
                                <h3>Explore the analysis</h3>
                                <p>
                                    Inspect architecture, dependencies, metrics and structural issues.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-section landing-section-dark">
                    <div className="landing-section-inner">
                        <div className="landing-center">
                            <p className="landing-eyebrow">Language support</p>
                            <h2>Start with Java. More languages are coming.</h2>
                            <p className="landing-center-text">
                                Custor is currently available for Java repositories, with Python
                                and Kotlin support planned next.
                            </p>
                        </div>

                        <div className="landing-languages">
                            <div className="landing-language">
                                <h3>Java</h3>
                                <p className="landing-available">Available now</p>
                            </div>

                            <div className="landing-language">
                                <h3>Python</h3>
                                <p>Coming soon</p>
                            </div>

                            <div className="landing-language">
                                <h3>Kotlin</h3>
                                <p>Coming soon</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-section landing-section-dark">
                    <div className="landing-section-inner">
                        <div className="landing-center">
                            <p className="landing-eyebrow">Plans</p>
                            <h2>Choose the level of analysis you need.</h2>
                            <p className="landing-center-text">
                                Start with PRO for everyday architecture analysis, or choose ENTERPRISE
                                for larger codebases and additional capabilities as Custor evolves.
                            </p>
                        </div>

                        <div className="landing-features">
                            <Feature title="PRO">
                                Full Custor analysis for your software projects, with support for
                                repositories up to 10,000 files and 2,000,000 lines of code.
                            </Feature>

                            <Feature title="ENTERPRISE">
                                Everything in PRO, with support for repositories up to 100,000 files
                                and 10,000,000 lines of code, plus additional capabilities as Custor evolves.
                            </Feature>
                        </div>
                    </div>
                </section>

                <section className="landing-section">
                    <div className="landing-section-inner">
                        <div className="landing-center">
                            <p className="landing-eyebrow">Pricing</p>
                            <h2>Simple pricing to get started.</h2>
                            <p className="landing-center-text">
                                Choose the plan that fits the size and needs of your codebase.
                            </p>
                        </div>

                        <div className="landing-pricing">
                            <div className="landing-price-card">
                                <p className="landing-price-label">Pro</p>
                                <div className="landing-price">
                                    <span>$29</span>
                                    <small>/ month</small>
                                </div>
                                <p className="landing-price-description">
                                    Architecture analysis, dependencies, code metrics and structural
                                    insights for repositories up to 10,000 files and 2,000,000 lines of code.
                                </p>
                                <Link to="/register" className="landing-button landing-button-primary">
                                    Get Started
                                </Link>
                            </div>

                            <div className="landing-price-card">
                                <p className="landing-price-label">Enterprise</p>
                                <div className="landing-price landing-price-custom">
                                    <span>$290</span>
                                    <small>/ year</small>
                                </div>
                                <p className="landing-price-description">
                                    Everything in PRO, with support for repositories up to 100,000 files
                                    and 10,000,000 lines of code, plus additional capabilities as Custor evolves.
                                </p>
                                <Link to="/register" className="landing-button landing-button-secondary">
                                    Get Started
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="landing-final">
                    <div className="landing-final-inner">
                        <p className="landing-eyebrow">Start exploring</p>
                        <h2>Understand your codebase before changing it.</h2>
                        <p>
                            Explore the structure of your software, understand its dependencies,
                            and identify areas that deserve attention.
                        </p>
                        <Link to="/register" className="landing-button landing-button-primary" style={{marginTop:"30px"}}>
                            Start with Custor
                        </Link>
                    </div>
                </section>
            </main>


            <footer className="landing-footer">
                <div className="landing-footer-inner">
                    <div className="landing-footer-brand">
                        <Link to="/" className="landing-logo">Custor</Link>
                        <p>Understand your codebase.</p>

                        <div className="landing-socials">
                            <a
                                href="https://x.com/Custor_pro"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Custor on X"
                                title="Follow Custor on X"
                            >
                                <XIcon />
                            </a>

                            {/* Add the Reddit URL when available */}
                            <span className="landing-social-placeholder" title="Reddit link coming soon">
                    <RedditIcon />
                </span>

                            {/* Add the Discord URL when available */}
                            <span className="landing-social-placeholder" title="Discord link coming soon">
                    <DiscordIcon />
                </span>
                        </div>
                    </div>

                    <div className="landing-footer-bottom">
                        <div className="landing-footer-copy">
                            © 2026 Custor
                        </div>

                        <div className="landing-footer-links">
                            <Link to="/terms">Terms of Service</Link>
                            <Link to="/privacy">Privacy Policy</Link>
                            <Link to="/refund">Refund Policy</Link>
                            <a href="mailto:support@custor.pro">Contact / Support</a>
                        </div>
                    </div>
                </div>
            </footer>

        </div>
    );
}